import * as Types from './types.generated';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type HasEmailValidatedQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type HasEmailValidatedQuery = { __typename?: 'Query', hasEmailValidated: boolean };


export const HasEmailValidatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"hasEmailValidated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasEmailValidated"}}]}}]} as unknown as DocumentNode<HasEmailValidatedQuery, HasEmailValidatedQueryVariables>;